import { Alert, Anchor } from '@mantine/core';
import { IconBulb } from '@tabler/icons-react';
import { useDispatch, useSelector } from 'react-redux';
import { setSuggestSubscriptionModal } from '../store/subscriptionSlice';

const SuggestSubscriptionAlert = () => {
  const { suggestSubscriptionAlert } = useSelector((state) => state.subscription);
  const { account } = useSelector((state) => state.account);

  const dispatch = useDispatch();
  if (!suggestSubscriptionAlert || !account.canManageSubscriptions) {
    return null;
  }

  return (
    <Alert color="blue" icon={<IconBulb size={18} />} mb="md">
      <Anchor component="span" fw={500} style={{ cursor: 'pointer' }} onClick={() => dispatch(setSuggestSubscriptionModal(true))}>
        Upgrade your subscription
      </Anchor>{' '}
      to access this feature.
    </Alert>
  );
};

export default SuggestSubscriptionAlert;
